// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__25SGt","productName":"Table_productName__2eRxF"};